import AddIcon from "@material-ui/icons/Add";
import React, { FC, useState } from "react";

import Button from "../../../../../components/elements/Button";
import CreateCustomDomainListModal from "../CreateCustomDomainListModal";
import classes from "../../PublicationListSelectionSlide.module.scss";
import { CustomDomainList } from "../../../../../types/campaignTypes";

type CustomDomainListCreateButtonProps = {
  isLoading: boolean;
  createDomainList: (
    bgAdvertiserId: string,
    name: string,
    domains: string[],
    saveCreatedDomainList: (createdDomainList: CustomDomainList) => void,
  ) => void;
};

const CustomDomainListCreateButton: FC<CustomDomainListCreateButtonProps> = ({ isLoading, createDomainList }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  return (
    <div className={classes.customDomainListCreateBtn}>
      <Button disabled={isLoading} onClick={handleOpen}>
        Create Your Own List <AddIcon />
      </Button>
      <CreateCustomDomainListModal isOpen={isModalOpen} handleClose={handleClose} createDomainList={createDomainList} />
    </div>
  );
};

export default CustomDomainListCreateButton;
